import { Component } from '@angular/core';

import { EmptyStateComponent } from '@echospaces-web-monorepo/es-shared-ui';

/**
 * Coming-soon stub for tenant branding overrides (logo + color tokens).
 * Frontend BrandingService primitives exist in `es-shared-theme`; this
 * page lands once the Keycloak-org-attribute persistence + admin upload
 * flow are in place.
 */
@Component({
  selector: 'es-admin-branding-page',
  imports: [EmptyStateComponent],
  template: `
    <div class="max-w-4xl mx-auto">
      <div class="mb-6">
        <h1 class="text-2xl font-bold font-exo">Branding</h1>
        <p class="text-sm text-[var(--text-secondary)]">
          Customize your tenant's appearance — coming soon.
        </p>
      </div>
      <es-empty-state
        title="Branding tools"
        description="Logo upload, color tokens, and per-tenant theme overrides will land here once the persistence layer ships."
        icon="🎨"
      ></es-empty-state>
    </div>
  `,
})
export class AdminBrandingPageComponent {}
